export enum MapPinKind {
  Coordinates = 'coordinates',
  Place = 'place',
}

export enum MapDirectiveKey {
  Title = 'title',
  Zoom = 'zoom',
  Center = 'center',
  /** Reserved for v2 routing. Parsed and ignored so it never becomes a pin. */
  Route = 'route',
}
